import { providerState, sessionState } from "@/state"
import ProviderError from "@/model/provider/ProviderError"

export const retrieveAcceptOfferError = function() {
    return providerState.getError(sessionState.providerKey, ProviderError.ACCEPT_OFFER_SOFT_ERROR) ||
        providerState.getError(sessionState.providerKey, ProviderError.ACCEPT_OFFER_ERROR)
}

export const removeAcceptOfferError = function() {
    providerState.removeError(sessionState.providerKey, ProviderError.ACCEPT_OFFER_SOFT_ERROR)
    providerState.removeError(sessionState.providerKey, ProviderError.ACCEPT_OFFER_ERROR)
}
